module.exports = __webpack_public_path__ + "img/arrow_right_square.133ab527.svg";